export const AppEvent = {
  SOCKET_CONNECT: "socket_connect",
  AUTH_ERROR: "auth_error",
  AUTH_TOKEN_UNAVAILABLE: "auth_token_unavailable",
  AUTH_TOKEN_REJECTED: "auth_token_rejected",
  AUTH_TOKEN_REFRESH_FAILED: "auth_token_refresh_failed",
  VPC_ERROR: "vpc_error",
  SETTINGS_ERROR: "settings_error",
  SUBSCRIPTION_ERROR: "subscription_error",
  RECONNECT_FAILED: "reconnect_failed",
  VOICE_SESSION_START: "voice_session_start",
  VOICE_SESSION_ERROR: "voice_session_error",
  AUDIO_PLAYER_INIT_FAILED: "audio_player_init_failed",
  MIC_RECORDING_FAILED: "mic_recording_failed",
  ESS_LOAD_FAILURE: "ess_load_failure",
  ESS_SAVE_FAILURE: "ess_save_failure",
  COMIC_START: "comic_start",
  COMIC_ERROR: "comic_error",
} as const;
